import { useGetSafeClientCode } from '@/hooks/router'
import { useNavigate } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'

import { InstrumentDto } from '@/gen/publicApi'

import InstrumentStateCircle from '@/components/instrumentStateCircle'
import { TableCell, TableRow } from '@/components/table'

interface Props {
    marketCode: string
    instrument: InstrumentDto
}

export default function InstrumentRow({ marketCode, instrument }: Props) {
    const clientCode = useGetSafeClientCode()
    const navigate = useNavigate()

    const onClick = () => {
        navigate({
            to: `/$client_code/markets/$market_code/instruments/$instrument_symbol`,
            params: {
                client_code: clientCode,
                market_code: marketCode,
                instrument_symbol: instrument.symbol,
            },
        })
    }

    return (
        <>
            <TableRow key={instrument.symbol} onClick={onClick} className="cursor-pointer">
                <TableCell>{instrument.symbol}</TableCell>
                <TableCell>
                    <InstrumentStateCircle className="mr-2" state={instrument.state} />
                    {instrument.name}
                </TableCell>

                <TableCell>
                    <div className="flex items-center justify-end">
                        <ChevronRight className="h-4 w-4" />
                    </div>
                </TableCell>
            </TableRow>
        </>
    )
}
